import React, { memo } from 'react';
import { ProductType } from '../../../hooks/useProducts';
import { formatPercentage } from '../../../lib/formatters';
import { Gwei } from '../../../lib/gwei';
import { alignToValidSize, divide, safeDivide } from '../../../lib/math';
import { StyledSlider } from '../../StyledSlider';
import { useMaxSize } from './hooks/useMaxSize';
import { useTradeFormStore } from './TradeFormState';

export const TradeFormSliderUi: React.FC<{
  product: ProductType;
  maxSize: bigint;
}> = ({ product, maxSize }) => {
  const amount = useTradeFormStore((s) => s.amount);
  const setAmount = useTradeFormStore((s) => s.setAmount);
  const step = Gwei.max(product.lotSize, divide(maxSize, Gwei.toGwei(100)));
  const disabled = maxSize === 0n;
  return (
    <StyledSlider
      className="mt-4"
      value={Gwei.min(Gwei.max(amount ?? 0n, 0n), maxSize)}
      max={maxSize}
      step={step}
      disabled={disabled}
      ariaLabel="Trade Amount Slider"
      onChange={(rawAmount) => {
        const amount = alignToValidSize(rawAmount, product.lotSize);
        setAmount(amount);
      }}
      formatValue={(x) =>
        formatPercentage(safeDivide(x, maxSize), {
          minimumFractionDigits: 0,
          maximumFractionDigits: 0,
        })
      }
    />
  );
};

export const TradeFormSlider: React.FC<{ product: ProductType }> = memo(({ product }) => {
  const maxSize = useMaxSize(product);
  return <TradeFormSliderUi product={product} maxSize={maxSize} />;
});
